<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";

export default {
  inject: ['setLoading'],

  data() {
    return {
      errors: {},
      title: "Reports",
      text: "Quotation Detailed Report",
      text1: "Reports",
      isCollapsed: false,
      app_currency: '',
      filter: {
        user: '',
        status: '',
        party_type: '',
        from_date: '',
        to_date: '',
        sort_by: '',
        sort_dir: '',
      },
      users: [],
      data: [],
      summary: {},
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
    };
  },

  computed: {
    serialNo() {
      return (this.pagination.current_page - 1) * this.pagination.per_page;
    },

    summaryCards() {
      const s = this.summary || {};
      return [
        { label: 'Total Quotations', value: s.total_quotations, icon: 'ti-file-text', accent: '#4f46e5', valueColor: '#1e293b', changePct: s.quotation_change_pct },
        { label: `Total Value (${this.app_currency.code || ''})`, value: this.formatCurrency(s.total_value), icon: 'ti-currency-rupee', accent: '#16a34a', valueColor: '#16a34a', changePct: s.value_change_pct },
        { label: 'Avg Quotation Value', value: this.formatCurrency(s.avg_quotation_value), icon: 'ti-calculator', accent: '#06b6d4', valueColor: '#1e293b', changePct: null },
        { label: 'Total Tax', value: this.formatCurrency(s.total_tax), icon: 'ti-receipt-tax', accent: '#f59e0b', valueColor: '#1e293b', changePct: null },
        { label: 'Unique Parties', value: s.unique_parties, icon: 'ti-users', accent: '#8b5cf6', valueColor: '#1e293b', changePct: null },
        { label: 'Sales Reps', value: s.unique_sales_reps, icon: 'ti-user-star', accent: '#ec4899', valueColor: '#1e293b', changePct: null },
      ];
    },

    cpqCards() {
      const cpq = (this.summary && this.summary.cpq) || {};
      return [
        { label: 'Lines With Options', value: `${cpq.lines_with_options || 0} / ${cpq.total_lines || 0}`, icon: 'ti-adjustments', accent: '#4f46e5' },
        { label: 'Option Value Added', value: this.formatCurrency(cpq.total_option_delta), icon: 'ti-plus', accent: '#16a34a' },
        { label: 'Lines With Tier Discount', value: cpq.lines_with_tier_discount || 0, icon: 'ti-stack-2', accent: '#f59e0b' },
        { label: 'Tier Discount Given', value: this.formatCurrency(cpq.tier_discount_amount), icon: 'ti-discount-2', accent: '#ef4444' },
      ];
    },
  },

  async mounted() {
   this.getUsers();
   this.app_currency = await this.$appCurrency();

   const start = moment().subtract(1, "month");
   const end = moment();

   new DateRangePicker(
    this.$refs.dateRangeInput,
    {
     startDate: start,
     endDate: end,
      locale: {
        format: "DD/MM/YYYY",
        separator: " - "
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      }
     },
     (start, end) => {
      this.setDateRange(start, end);
     },
     this.booking_range
    );

    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);

    //LOAD DATA
    this.filterReport();
  },

  methods: {
   booking_range(start, end) {
    return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
   },

   setDateRange(start, end) {
    this.filter.from_date = start.format("YYYY-MM-DD");
    this.filter.to_date = end.format("YYYY-MM-DD");
   },

   /** Strip empty/null/undefined keys so blank filters aren't sent as query params */
   buildPayload(extra = {}) {
    const payload = {
     user_id: this.filter.user,
     status: this.filter.status,
     party_type: this.filter.party_type,
     date_from: this.filter.from_date,
     date_to: this.filter.to_date,
     sort_by: this.filter.sort_by,
     sort_dir: this.filter.sort_dir,
     ...extra,
    };

    Object.keys(payload).forEach((key) => {
     if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
      delete payload[key];
     }
    });

    return payload;
   },

   async filterReport(page = 1) {
    this.errors = {};
    this.setLoading(true);
    try {
      const payload = this.buildPayload({
       page,
       per_page: this.pagination.per_page,
      });

      const query_string = new URLSearchParams(payload).toString();
      const response = await axios.get(`/reports/quotation?${query_string}`);
      const rows = response.data.data.rows;

      this.summary = response.data.data.summary || {};
      this.data = rows.data;

      this.pagination = {
       current_page: rows.current_page,
       per_page: rows.per_page,
       last_page: rows.last_page,
       total: rows.total,
       links: rows.links
      };

     }catch(error){
      if(error.type == 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     }
    },

    async getUsers() {
     this.setLoading(true);
     try{
      const response = await axios.get('/users/all-users');
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    /** Export - all columns, via same report endpoint using export=csv */
    async quickExport(format) {
     const payload = this.buildPayload({ export: format });
     await this.downloadExport('/reports/quotation', payload);
    },

    /** Reusable download method */
    async downloadExport(url, payload) {
     this.setLoading(true);
     try {
      const query_string = new URLSearchParams(payload).toString();
      const response = await axios.get(`${url}?${query_string}`, {
       responseType: 'blob',
      });

      const blob = new Blob([response.data], {
       type: response.headers['content-type'],
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      const format = payload.export;
      let filename = `quotation_report_${this.$timeStamp()}.${format}`;
      const disposition = response.headers['content-disposition'];

      if(disposition && disposition.indexOf('filename=') !== -1){
       const filenameMatch = disposition.match(/filename="?(.+)"?/);
       if(filenameMatch && filenameMatch.length === 2){
        filename = filenameMatch[1];
       }
      }

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      this.$swalToast('Export downloading...', 'success');
     }catch(error){
      console.error(error);
      this.$swalToast(error?.response?.data?.message || 'Export failed', 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url) {
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.filterReport(page);
    },

    clearFilter() {
      this.filter = {
        user: '',
        status: '',
        party_type: '',
        from_date: this.filter.from_date,
        to_date: this.filter.to_date,
        sort_by: '',
        sort_dir: '',
      };
      this.filterReport();
    },

    statusBadgeClass(status) {
     const map = {
      Draft: 'bg-secondary-subtle text-secondary',
      Sent: 'bg-info-subtle text-info',
      Accepted: 'bg-success-subtle text-success',
      Rejected: 'bg-danger-subtle text-danger',
      Pending: 'bg-warning-subtle text-warning',
      Price_Rejected: 'bg-danger-subtle text-danger',
      Superseded: 'bg-secondary-subtle text-secondary',
     };
     return map[status] || 'bg-light text-dark';
    },

    formatCurrency(val) {
     return parseFloat(val || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    },

    changePctClass(val) {
     const num = parseFloat(val || 0);
     if (num > 0) return 'text-success';
     if (num < 0) return 'text-danger';
     return 'text-muted';
    },

    changePctIcon(val) {
     const num = parseFloat(val || 0);
     if (num > 0) return 'ti ti-trending-up';
     if (num < 0) return 'ti ti-trending-down';
     return 'ti ti-minus';
    },
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <!-- Export Dropdown -->
          <div class="me-2 mb-2" v-if="data?.length">
            <div class="dropdown">
              <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="quickExport('csv')">
                    <i class="ti ti-file-type-csv me-1"></i>Export as CSV
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Summary Cards -->
      <div class="row g-3 mb-3" v-if="summary && summary.total_quotations !== undefined">
        <div class="col-xl col-md-4 col-6" v-for="card in summaryCards" :key="card.label">
          <div class="card mb-0 border-0 shadow-sm stat-card" :style="{ borderLeft: '3px solid ' + card.accent }">
            <div class="card-body p-3">
              <div class="d-flex align-items-center justify-content-between">
                <div class="overflow-hidden">
                  <span class="text-muted d-block text-truncate" style="font-size:11px;">{{ card.label }}</span>
                  <span class="fw-bold d-block" :style="{ color: card.valueColor, fontSize: '20px' }">{{ card.value }}</span>
                  <span v-if="card.changePct != null" :class="changePctClass(card.changePct)" style="font-size:11px;">
                    <i :class="changePctIcon(card.changePct)" style="font-size:12px;"></i> {{ Math.abs(card.changePct) }}%
                  </span>
                </div>
                <span class="avatar rounded-circle flex-shrink-0" :style="{ background: card.accent + '1a' }">
                  <i class="ti" :class="card.icon" :style="{ color: card.accent }" style="font-size:18px;"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CPQ Usage (only shown when this tenant actually has CPQ activity) -->
      <div class="row g-3 mb-3" v-if="summary.cpq && summary.cpq.total_lines > 0">
        <div class="col-md-3 col-6" v-for="card in cpqCards" :key="card.label">
          <div class="card mb-0 border-0 shadow-sm stat-card" :style="{ borderLeft: '3px solid ' + card.accent }">
            <div class="card-body p-3">
              <div class="d-flex align-items-center justify-content-between">
                <div class="overflow-hidden">
                  <span class="text-muted d-block text-truncate" style="font-size:11px;">{{ card.label }}</span>
                  <span class="fw-bold d-block text-dark" style="font-size:18px;">{{ card.value }}</span>
                </div>
                <span class="avatar rounded-circle flex-shrink-0" :style="{ background: card.accent + '1a' }">
                  <i class="ti" :class="card.icon" :style="{ color: card.accent }" style="font-size:16px;"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card border-0">
        <div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
          <div class="d-flex align-items-center flex-wrap mb-1">
            <div class="me-3" v-if="filter.user !== '' || filter.status !== '' || filter.party_type !== ''">
              <a href="javascript:void(0);" class="text-danger" @click="clearFilter()">
                <i class="ti ti-filter-x"></i>
              </a>
            </div>

            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
                <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
              </div>
            </div>

            <div class="me-3">
              <select class="form-select" v-model="filter.user">
                <option value="">User</option>
                <option :value="row.id" v-for="row in users" :key="row.id">{{row.name}}</option>
              </select>
              <div class="text-danger small mt-1" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
            </div>

            <div class="me-3">
              <select class="form-select" v-model="filter.status">
                <option value="">Status</option>
                <option value="Draft">Draft</option>
                <option value="Sent">Sent</option>
                <option value="Accepted">Accepted</option>
                <option value="Rejected">Rejected</option>
                <option value="Pending">Pending</option>
                <option value="Price_Rejected">Price Rejected</option>
                <option value="Superseded">Superseded</option>
              </select>
              <div class="text-danger small mt-1" v-if="errors.status">{{ errors.status[0] }}</div>
            </div>

            <!-- TODO: confirm exact party_type values with backend (App\Models\Lead / App\Models\Customer, as seen in QuotationController@create) -->
            <div class="me-3">
              <select class="form-select" v-model="filter.party_type">
                <option value="">Party Type</option>
                <option value="App\Models\Lead">Lead</option>
                <option value="App\Models\Customer">Customer</option>
              </select>
              <div class="text-danger small mt-1" v-if="errors.party_type">{{ errors.party_type[0] }}</div>
            </div>

            <div class="me-3">
              <button type="button" class="btn btn-dark" @click="filterReport()">
                <i class="ti ti-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card border-0 shadow-sm">
            <div class="custom-datatable-filter table-responsive">
              <table class="table table-hover align-middle mb-0" v-if="data?.length">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Quotation No</th>
                    <th>Subject</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Client</th>
                    <th class="text-end">Amount</th>
                    <th>Closure Probability</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in data" :key="row.id">
                    <td class="text-muted">{{ serialNo + index + 1 }}.</td>
                    <td>
                      <h6 class="fs-14 fw-medium mb-0">
                        <a :href="`/sales/quotations/view/${row.public_token}`" target="_blank">{{ row.quotation_number }}</a>
                      </h6>
                    </td>
                    <td>
                      <h6 class="fs-14 fw-medium mb-0">
                        <a :href="`/sales/quotations/view/${row.public_token}`" target="_blank">{{ row.subject }}</a>
                      </h6>
                    </td>
                    <td>{{ $formatDate(row.quotation_date) }}</td>
                    <td>
                      <span class="badge rounded-pill" :class="statusBadgeClass(row.status)">{{ row.status?.replace('_', ' ') }}</span>
                    </td>
                    <td>
                      <span class="d-flex align-items-center">
                        <span class="avatar avatar-sm rounded-circle bg-light text-primary fw-bold me-2 flex-shrink-0 d-flex align-items-center justify-content-center" style="width:26px;height:26px;font-size:11px;">
                          {{ (row.created_by?.name || '?').charAt(0).toUpperCase() }}
                        </span>
                        <span class="text-truncate">{{ row.created_by?.name || '-' }}</span>
                      </span>
                    </td>
                    <td>
                      <h6 class="fs-14 fw-medium mb-0">
                        <a :href="$partyURL(row.party_id, row.party_type)" target="_blank">{{ row.party?.name }}</a>
                      </h6>
                      <small class="text-muted" v-if="row.party?.company_name">{{ row.party.company_name }}</small>
                    </td>
                    <td class="text-end">
                      <strong class="text-dark">{{ row.party?.currency?.code }} {{ row.total }}</strong>
                    </td>
                    <td>
                      <div v-if="row.closure_probability" class="d-flex align-items-center" style="min-width:90px;">
                        <div class="progress flex-grow-1 me-2" style="height:6px;">
                          <div class="progress-bar bg-success" :style="{ width: row.closure_probability + '%' }"></div>
                        </div>
                        <small class="fw-semibold">{{ row.closure_probability }}%</small>
                      </div>
                      <span v-else class="text-muted">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-else class="p-4 text-center text-muted">
                <i class="ti ti-file-off d-block mb-2" style="font-size:32px;"></i>
                No records found.
              </div>

              <!-- Pagination -->
              <nav v-if="pagination.links && pagination.links.length > 3" class="p-3">
                <ul class="pagination pagination-sm mb-0">
                  <li v-for="(link, index) in pagination.links" :key="index"
                    :class="['page-item', { active: link.active, disabled: !link.url }]">
                    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</template>
<style scoped>
.table-responsive {
  overflow-y: auto;
}
.stat-card {
  transition: transform .15s ease, box-shadow .15s ease;
}
.stat-card:hover {
  transform: translateY(-2px);
}
.avatar {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
</style>